module.exports = __webpack_public_path__ + "zvetseni-prsou_13_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_13_before.jpg
// module id = 1300
// module chunks = 0